module.exports = __webpack_public_path__ + "img/17.982530c1.jpg";